import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    selected: [],
    selectedNames: []
};

export const modelsSelectedSlice = createSlice({
    name: 'modelsSelected',
    initialState: initialState,
    reducers: {
        edit: (state, payload) => {
            if(payload.payload === "default"){
                state = initialState;
            }
            else {
                state = {
                    ...state, 
                    ...payload.payload
                };
            }
            return state;
        }
    },
})

export const { edit } = modelsSelectedSlice.actions

export default modelsSelectedSlice.reducer